import { has } from 'lodash';

const handleViewportHeight = () => {
    const viewportHeight = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${viewportHeight}px`);
}

const handleForbidden = () => {
    dispatchEvent(
        new CustomEvent("notify", {
            detail: {
                title: "Oops!",
                text: "Your session has expired. Please log in again to continue accessing the content.",
                type: "info"
            }
        })
    );

    setTimeout(() => location.reload(), 2500);
}

const overflow = document.documentElement.style.overflow;
const paddingRight = document.documentElement.style.paddingRight;
const preventDefault = (e) => e.preventDefault();

const disableScroll = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;

    if (document.getElementById('topbar') instanceof HTMLElement) {
        document.getElementById('topbar').style.paddingRight = `${scrollbarWidth}px`;
    }

    document.body.addEventListener('touchmove', preventDefault, { passive: false });
}

const enableScroll = () => {
    setTimeout(() => {
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;

        if (document.getElementById('topbar') instanceof HTMLElement) {
            document.getElementById('topbar').style.paddingRight = '0px';
        }

        document.body.removeEventListener('touchmove', preventDefault, { passive: false });
    }, 200);
}

const play = (audioId) => {
    if(localStorage.getItem('enableAudio') === 'disabled') return;
    
    const audioBuffers = Alpine.store('audioBuffers');

    if (
        audioBuffers &&
        typeof audioBuffers.hasBuffer === 'function' &&
        audioBuffers.buffers &&
        audioBuffers.hasBuffer(audioId) &&
        audioBuffers.buffers[audioId]
    ) {
        audioBuffers.playFromBuffer(audioId);
    } else {
        const audio = document.getElementById(audioId);
        if (audio) {
            audio.currentTime = 0;
            if (audio.readyState >= 2) {
                audio.play();
            } else {
                audio.addEventListener('canplaythrough', () => audio.play(), { once: true });
            }
        }
    }
}

const preloadAudioBuffers = (selector = '#audio-sources audio') => {
    Alpine.store('audioBuffers', {
        init() {
            this.buffers = {};
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            this.audioElements = document.querySelectorAll(selector);

            this.audioElements.forEach(audioEl => {
                fetch(audioEl.src)
                    .then(response => response.arrayBuffer())
                    .then(arrayBuffer => this.audioContext.decodeAudioData(arrayBuffer))
                    .then(decodedData => this.buffers[audioEl.id] = decodedData)
                    .catch(error => console.error(`Error loading ${audioEl.id}:`, error))
            });
        },

        playFromBuffer(audioId) {
            if (this.buffers[audioId]) {
                const source = this.audioContext.createBufferSource();
                source.buffer = this.buffers[audioId];
                source.connect(this.audioContext.destination);
                source.start(0);
            } else {
                console.warn(`Audio buffer for '${audioId}' not found.`);
            }
        },

        hasBuffer(audioId) {
            return has(this.buffers, audioId);
        }
    });
}

export { handleViewportHeight, handleForbidden, disableScroll, enableScroll, play, preloadAudioBuffers };
